import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/common/header";
import { useUserWallet, useWalletLedgers } from "./hooks/use-wallet";
import { groupLedgersByMonth } from "./utils/wallet-utils";
import LedgerGroup from "./components/ledger-group";
import WithdrawalRequestModal from "./components/withdrawal-request-modal";
import { calculateMaxWithdrawable } from "./utils/wallet-utils";
import { useWithdrawalRequests } from "./hooks/use-wallet";

const WalletPage = () => {
  const navigate = useNavigate();
  const {
    wallet,
    loading: walletLoading,
    refetch: refetchWallet,
  } = useUserWallet();
  const {
    ledgers,
    loading: ledgersLoading,
    refetch: refetchLedgers,
  } = useWalletLedgers();
  const { withdrawalRequests } = useWithdrawalRequests();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const availableBalance = wallet?.availableBalance || 0;
  const maxWithdrawable = calculateMaxWithdrawable(availableBalance);
  const hasPendingWithdrawal = withdrawalRequests.some(
    (req) => req.status === "REQUESTED" || req.status === "APPROVED"
  );

  const groupedLedgers = groupLedgersByMonth(ledgers);
  const hasLedgers = Object.keys(groupedLedgers).length > 0;

  const handleWithdrawalSuccess = () => {
    refetchWallet();
    refetchLedgers();
  };

  const handlePolicyClick = () => {
    // TODO: 정책 페이지로 이동
    navigate("/my/policy");
  };

  if (walletLoading || ledgersLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <div className="text-gray-500">로딩 중...</div>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen bg-white">
      {/* Header */}
      <Header showBackButton title="보유 예치금">
        <Header.RightContent>
          <button
            onClick={handlePolicyClick}
            className="text-gray-600 hover:text-gray-800 text-sm"
          >
            정책
          </button>
        </Header.RightContent>
      </Header>

      {/* 잔액 요약 영역 */}
      <div className="w-full px-4 py-12 flex flex-col items-center">
        <div className="text-6xl font-bold text-gray-900 mb-2">
          {availableBalance.toLocaleString()}원
        </div>
        <p className="text-gray-500 text-sm">
          예치금과 페이백이 합산된 금액이에요
        </p>
      </div>

      {/* 출금 버튼 */}
      <div className="w-full px-4 pb-6">
        <button
          onClick={() => setIsModalOpen(true)}
          disabled={maxWithdrawable < 1000 || hasPendingWithdrawal}
          className={`w-full py-4 rounded-xl font-semibold text-lg transition-all ${
            maxWithdrawable < 1000 || hasPendingWithdrawal
              ? "bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed"
              : "bg-[#1692fc] text-white hover:bg-[#1562fc] active:scale-[0.98]"
          }`}
        >
          출금하기
        </button>
        {hasPendingWithdrawal && (
          <p className="text-center text-sm text-gray-500 mt-2">
            처리 중인 출금 요청이 있어요
          </p>
        )}
        {maxWithdrawable >= 1000 && !hasPendingWithdrawal && (
          <p className="text-center text-sm text-gray-500 mt-2">
            출금은 1,000원 단위로만 가능해요
          </p>
        )}
      </div>

      {/* 지갑 내역 리스트 */}
      {hasLedgers ? (
        <div className="w-full pb-8">
          {Object.entries(groupedLedgers).map(([yearMonth, monthLedgers]) => (
            <LedgerGroup
              key={yearMonth}
              yearMonth={yearMonth}
              ledgers={monthLedgers}
            />
          ))}
        </div>
      ) : (
        <div className="w-full px-4 py-12 text-center">
          <p className="text-gray-500 text-sm">
            아직 출금 가능한 금액이 없어요
          </p>
          <p className="text-gray-500 text-sm mt-1">
            챌린지에 참여해 페이백을 받아보세요!
          </p>
        </div>
      )}

      {/* 출금 요청 모달 */}
      <WithdrawalRequestModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleWithdrawalSuccess}
      />
    </div>
  );
};

export default WalletPage;
